<template>
    <div id="systemmodule">
        <HrrBreadcrumb PMname="其他功能" CMname="卡片信息管理" />
        <HrrDetailLayout>
            <template slot="head">
                {{title}}
            </template>
            <template slot="Form">
                <el-form status-icon :model="form" ref="form" :rules="rules" label-width="130px" class="el-form-module" :hide-required-asterisk="isView">
                    <el-form-item label="批次号：" prop="myBatch">
                        <el-input v-model="form.myBatch" v-if="isAdd" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商：" prop="supplier">
                        <el-input v-model="form.supplier" v-if="isAdd" ></el-input>
                    </el-form-item>
                    <el-form-item label="批量生成个数：" prop="CreateNum" >
                        <el-input v-model="form.CreateNum" v-if="isAdd" oninput="value=value.replace(/[^\d]/g,'')" maxLength=4></el-input>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button type="primary" @click="submitMForm('form')" v-if="isAdd||isEdit">提 交</el-button>
                <el-button @click="resetMForm('form')" v-if="isEdit">重 置</el-button>
                <el-button type="info" @click="returnMForm()">返 回</el-button>
            </template>
        </HrrDetailLayout>
    </div>
</template>
<script>
export default {
    name: 'carddetail',
    data() {
        return {
            form: {
                myBatch:"",
				supplier:"",
				CreateNum:"",
            },
            rules: {
                supplier: [{ required: true, message: '请输入供应商', trigger: 'blur' }],
                CreateNum: [{ required: true, message: '请输入批量生成个数', trigger: 'blur' }],
            },
            title: "",
            isEdit: true,
            isAdd: false,
            isView: false,
        }
    },
    methods: {
        submitMForm: function(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var apiUrl = this.$api.card.getCard;
                    var m = "POST";
                    this.$hrraxios({
                            method: m,
                            url: apiUrl,
                            data: this.form
                        })
                        .then(function(response) {
                            loading.close();
                            var data = response.data;
                            if (data.Success == true) {
                                Vuethis.$alert("提交成功！", {
                                    callback: action => {
                                        Vuethis.$router.push({ path: '/card/info/' });
                                    }
                                });
                            } else {
                                Vuethis.$message({ message: data.Prompt, type: "error" });
                            }
                        }).catch(function(error) {
                            loading.close();
                            console.log(error);
                        })
                } else {
                    return false;
                }
            });
        },
        resetMForm: function(formName) {
            this.$refs[formName].resetFields();
        },
        returnMForm: function() {
            this.$router.go(-1);
        },
        initData: function() {
            this.isView = false;
            this.isEdit = false;
            this.isAdd = false;
            var Hrrtype = this.$route.params.type; //类型
            var row = this.$route.meta.row;
            var info = "卡片信息";
            if (Hrrtype != "add") {
                this.form = row;
                this.$route.meta.row = null;
            }
            if (Hrrtype == "view") {
                this.title = "查看" + info;
                this.isView = true;
            }
            if (Hrrtype == "edit") {
                this.title = "编辑" + info;
                this.isEdit = true;

            }
            if (Hrrtype == "add") {
                this.title = "批零增加" + info;
                this.isAdd = true;
            }
              var myVuethis = this;
            //所属地铁站
            this.$hrraxios.get(this.$api.card.getBatchNew)
                .then((response) => {
                    var data = response.data;
                    myVuethis.form.myBatch = data.Data;
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    },
    created: function() {
        this.$route.meta.row!=undefined?localStorage.setItem("row",JSON.stringify(this.$route.meta.row)):"";
        localStorage.getItem("row")!=undefined? this.$route.meta.row=JSON.parse(localStorage.getItem("row")):"";
        this.initData();
    }
}
</script>
<style>
.el-form-module {
    width: 500px;
}

span.level1 {
    padding-left: 0;
}

span.level2 {
    padding-left: 12px;
}

span.level3 {
    padding-left: 24px;
}

span.level4 {
    padding-left: 36px;
}
</style>